{
  "recordingFilterBar": {
    "text": "最古データ:",
    "text2": "最新データ:",
    "label": "録画日",
    "previousDay": "前の日",
    "nextDay": "次の日"
  },
  "recordingTable": {
    "label": "録画時刻",
    "text": "{{value}}時台",
    "label2": "ファイルサイズ",
    "label3": "再生",
    "text2": "再生する"
  },
  "recording": {
    "title": "録画履歴",
    "alert": "録画履歴の取得に失敗しました",
    "alert2": "この日の録画はありません"
  }
}
